import React from "react";

const LoginInput = ({ name, type, placeholder, value, onChange, ...rest }) => {
  return <input name={name} type={type} placeholder={placeholder} value={value} onChange={onChange} {...rest}/>;
};

export default LoginInput;
